import React from 'react';
import { Navigate } from 'react-router-dom';
import { PicksView } from '@shared/ui/picks/PicksView';
import { Versioned } from '@shared/ui/uiVersion';
import { MainLayout } from '../layouts';
import { usePageDocumentTitle } from '../hooks/useDocumentTitle';

/**
 * The signed-out preview of past days' high-probability picks, in this app's frame (ADR-0008).
 * Only members can be on classic, and they have the full page.
 */
const PreviewPicksPage: React.FC = () => {
  usePageDocumentTitle('Free High-Probability Racing Picks');
  return (
    <Versioned classic={<Navigate to="/high-probability" replace />}>
      <MainLayout>
        <PicksView preview />
      </MainLayout>
    </Versioned>
  );
};

export default PreviewPicksPage;
